import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { BehaviorSubject, Subject } from 'rxjs';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';
import { ListaPrecoTabela, Tipo } from '../../../../../shared/interfaces/lista-preco-tabela';
import { ListaPrecoService } from '../../../../../shared/services/lista-preco.service';
import { MatPaginator } from '@angular/material/paginator';
import { PageResult } from '../../../../../shared/interfaces/page-result';
import { Utils } from 'app/utils/utils';
import { MatRipple } from '@angular/material/core';
import { ListaPrecoTabelaService } from '../../../../../shared/services/lista-preco-tabela.service';

@Component({
  selector: 'app-tabela-table-popup',
  templateUrl: 'tabela-table-popup.component.html',
  styleUrls: ['tabela-table-popup.component.scss']
})
export class TabelaTablePopupComponent implements OnInit {
  public itemForm: FormGroup;
  public itemDiretivasFatForm: FormGroup;

  tabelas: TabelaTablePopupComponent[];
  tabela: TabelaTablePopupComponent;
  tipo: Tipo[];
  cep: any;
  isLoading = false;
  isLoadingGrupo = false;
  errorMsg: string;


  selected = [];

  pageObject$: BehaviorSubject<PageResult<ListaPrecoTabela>> = new BehaviorSubject<PageResult<ListaPrecoTabela>>(null);
  searchEntry$: Subject<string> =  new Subject<string>();

  Utils = Utils;
  @ViewChild(MatRipple, {static: false}) ripple: MatRipple;
  public searchInput = '';
  selectedTabela = '';

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  rows = [];
  rowIndex;
  isEditable = {};

  maskFone = {
    mask: '(00) {*}0000-0000',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCep = {
    mask: '00000-000',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCpf = {
    mask: '000.000.000-00',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCnpj = {
    mask: 'SS.SSS.SSS/SSSS-00',
    definitions: { S: /[0-9A-Za-z]/ },
    prepare: (str: string) => (str || '').toUpperCase(),
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };
  maskUpper = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toUpperCase()
  };
  maskLower = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toLowerCase()
  };

  maskEmail = {
    mask: /^\S*@?\S*$/,
    prepare: (email: any) => email.toLowerCase()
  };


  page = 1;
  length = 0;
  pageSize = 10;
  pageEvent  = null;
  pageSizeOptions: number[] = [5, 10, 25, 100];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<TabelaTablePopupComponent>,
    private fb: FormBuilder,
    private confirmService: AppConfirmService,
    private tabelaService: ListaPrecoTabelaService
  ) { }

  ngOnInit() {
    
    this.buildItemForm(this.data.payload)
  }

  buildItemForm(item: ListaPrecoTabela) {
    this.itemForm = this.fb.group({
      id: [item.id],
      codigo: [item.codigo,[Validators.required]],
      desativado: [item.desativado],
      descricao: [item.descricao,[Validators.required]], 
      percentualAcrescimo: [item.percentualAcrescimo],
      tipo: [item.tipo,[Validators.required]],
      indice: [item.indice,[Validators.required]],
      tabela: [item.tabela,[Validators.required]],
      listaUUID: [item.listaUUID],
      statusSync: [item.statusSync],
      logErro: [item.logErro]
    })


  }


  submit() {
    // console.log( this.itemForm.value.endereco);
    // this.itemForm.value.inscricaoFederal = this.itemForm.value.cpfCnpj;
    // this.itemForm.value.cpf = this.itemForm.value.cpfCnpj;
    // this.itemForm.value.rg = this.itemForm.value.rgInscricao;
    // this.itemForm.value.inscricaoEstadual = this.itemForm.value.rgInscricao;
    this.dialogRef.close(this.itemForm.value)
  }

  getPage(page: number, pageSize: number ) {
    this.tabelaService.getTabelaPage(page, pageSize).subscribe(val => this.pageObject$.next(val));
  }

  getSearchPage(search: string, page: number, pageSize: number ) {
    if ( page === 1) {
      this.paginator.firstPage();
    }
    if (search === null || search === undefined || search.length === 0) {
      this.getPage(1, this.pageSize);
    } else {
      this.tabelaService.getTabelaPageSearch(-1, page, pageSize, search).subscribe ( val => this.pageObject$.next(val));
    }
  }

  close() {
    this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
      .subscribe(res => {
        if (res) {
          this.dialogRef.close(false);
        }
      });
    }

}
